import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Button from "../components/Button";
import {toast} from "react-toastify";
import ArchiveTemplateSettingModal from "../modals/ArchiveTemplateSettingModal";

const TemplateSettingDataTable = () => {
    const dataTableRef = useRef(null);

    const [archiveTemplateSettingModal, setArchiveTemplateSettingModal] = useState(null);

    const renderRowButton = (templateSetting) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!templateSetting.can && (templateSetting.can.update === true || templateSetting.can.delete === true) && (
                        <div className="dropdown">
                            <button
                                className="dropdown-toggle cursor-pointer text-eh-off-black h3"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i className="far fa-ellipsis-h"/>
                            </button>
                            <div
                                className="dropdown-menu dropdown-menu-right p-0"
                                aria-labelledby="navbarDropdown"
                            >
                                {!!templateSetting.can.update === true && (
                                    <a className={"dropdown-item cursor-pointer"}
                                       href={route('template-setting.edit', {template_setting: templateSetting.id})}
                                    >
                                        <span>Edit</span>
                                    </a>
                                )}
                                {!!templateSetting.can.delete === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setArchiveTemplateSettingModal(templateSetting)}
                                    >
                                        <span>Delete</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card classes={"mh-100 border-0"} noPadding={true}>
                <div className={"row m-0 mb-4 p-0 d-flex justify-content-lg-between"}>
                    <div className="col-12 m-0 p-0">
                        <div className={"d-flex justify-content-end"}>
                            {can('create', 'templateSetting') && (
                                <Button
                                    href={route('template-setting.create').toString()}
                                    label={"Create Template"}
                                    icon={"far fa-plus-circle"}
                                    classes={"ml-4 btn btn-eh-lilac px-3 m-0"}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.template-setting.data-table').toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="template settings" />}
                                fieldsToExclude={[
                                    'id',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldMap={{
                                    name:               "Template Name",
                                    deposit_percentage: "Deposit %",
                                    created_at:         "Created Date",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'name'}
                                defaultOrderByDirection={'asc'}
                                buttons={(row) => renderRowButton(row)}
                            />
                        </div>
                    </div>
                </div>
            </Card>
            <ArchiveTemplateSettingModal
                show={!!archiveTemplateSettingModal}
                templateSetting={!!archiveTemplateSettingModal ? archiveTemplateSettingModal : null}
                parentId={'template-settings-datatable'}
                onCancel={() => setArchiveTemplateSettingModal(null)}
                onConfirm={() => {
                    setArchiveTemplateSettingModal(null);
                    dataTableRef.current.reload();
                    toast.success(<div>{"Template deleted."}</div>);
                }}
            />
        </React.Fragment>
    );
}

export default TemplateSettingDataTable;

const target = document.getElementById('template-settings-datatable');
if (target) {
    ReactDOM.render(<TemplateSettingDataTable />, target);
}
